import React, { useRef, useState } from "react";
import { Box, SpanStyled } from "../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import {
  NavSidebarWrapper,
  ProfileBannerWrapper,
  ProfileContent,
  ProfileWrapper,
} from "./styled";
import { tabsArrayList } from "./TabsArray";
import { Link } from "react-router-dom";
import BannerImage from "./components/BannerImage";
import ProfileImageUpload from "./components/ProfileImageUpload";
import { ProfileSidebarList } from "../../../helpers/webConstants";
import UpdateCoverImage from "./components/UpdateCoverImage";
import ProfileApi from "../../../services/api/profileApi";
import { toast } from "react-toastify";
import { useUser } from "../../../context/userContext";

const Profile = () => {
  const { t } = useTranslation();
  const { fetchUserInfo } = useUser();
  const sidebarRef = useRef();
  const [activeTab, setActiveTab] = useState(tabsArrayList[0]);

  const updateProfileOrCover = async (dataObj) => {
    try {
      const formData = new FormData();
      Object.entries(dataObj).forEach(([key, value]) => {
        formData.append(key, value);
      });
      const { message, code } = await ProfileApi.updateProfileOrCover(formData);
      if (code === 200) {
        if (dataObj?.cover) {
          toast.success(t("cover_image_updated"));
        } else {
          toast.success(t("profile_image_updated"));
        }
        fetchUserInfo();
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {}
  };
  return (
    <ProfileWrapper>
      <ProfileBannerWrapper>
        <UpdateCoverImage cameraImage={true} handleCoverUpdate={updateProfileOrCover} />
        <Box className="profileContentWrapper justify-content-center">
          <ProfileImageUpload cameraImage={true} handleImageUpload={updateProfileOrCover} />
        </Box>
      </ProfileBannerWrapper>
      <Box className="profileContainer">
        <NavSidebarWrapper className={`SideBar`} ref={sidebarRef}>
          <Box className="text-center">
            <Box className="sidebar-list custom-scroll">
              <ul className="list-unstyled mb-0 pt-3">
                {ProfileSidebarList.map((item, key) => {
                  return (
                    <li
                      key={item.title + key}
                      className={` mb-2`}
                      onClick={() => setActiveTab(tabsArrayList[key])}
                    >
                      <Link
                        className={`text-decoration-none d-flex align-items-center ${
                          item.title === activeTab.title ? "active" : ""
                        }`}
                      >
                        <Box className="list-icon">
                          <item.icon />
                        </Box>
                        <Box>
                          <SpanStyled
                            className="text-capitalize d-flex"
                            style={{ textAlign: "start" }}
                          >
                            {t(item.title)}
                          </SpanStyled>
                        </Box>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </Box>
          </Box>
        </NavSidebarWrapper>
        <ProfileContent>
          <activeTab.component />
        </ProfileContent>
      </Box>
    </ProfileWrapper>
  );
};

export default Profile;
